import { useCheckoutStore } from '@entities/order'
import { useCheckoutApi } from '@entities/order'
import { useCommonStore } from '@shared/model'
import { trackEvent } from '@shared/lib/amplitude'
import { show404 } from '@shared/lib/page-error'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware( async (to) => {
  const order = to.params?.order as string | undefined
  const notifyType = (to.query.notify_type || null) as string | null
  const validOrder: boolean = typeof order === 'string'

  if (!validOrder) return show404()

  const commonStore = useCommonStore()
  const checkoutStore = useCheckoutStore()

  const orderId = Number(order)
  const validOrderId = Number.isInteger(orderId) && orderId > 0

  if (!validOrderId) return show404()

  checkoutStore.setNotifyType(notifyType)

  void useCheckoutApi({ orderId, route: to, mode: 'enter' }, {
    onStart: () =>{
      commonStore.setLoading(true)
    },
    onSuccess: () => {
      trackEvent('Page_view', { ...checkoutStore.getEventProps, feature: 'checkout', name: 'checkout' })
    },
    onFinish: () => {
      commonStore.setLoading(false)
    },
  })
})
